<ng-container [ngSwitch]="currentComponentStyleClass">
  <ng-container *ngSwitchCase="quickLinksClass">
    <dcp-quick-links></dcp-quick-links>
  </ng-container>
  <ng-container *ngSwitchCase="helpIconClass">
    <dcp-help-icon></dcp-help-icon>
  </ng-container>
  <ng-container *ngSwitchCase="userMenuClass">
    <dcp-user-menu [dcpDropdownPosition]="userMenu" #userMenu></dcp-user-menu>
  </ng-container>
</ng-container>
